import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  notFoundPageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginLeft: '2.5rem !important',
    marginRight: '2.5rem !important',
    marginTop: '170px',
    '@media (max-width:600px)': {
      marginTop: '170px',
    },
    '@media (max-width:520px)': {
      marginTop: '205px',
    },
    '@media (max-width:360px)': {
      marginTop: '240px',
    },
  },
  text: {
    color: 'lightgray',
  },
}));
